module.exports = __webpack_public_path__ + "img/pro_jinniao_04.1de9de6c.png";